/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AddressService {

    /**
     * AutoComplete the Address by ZipCode
     * AutoComplete the Address by ZipCode
     * @param zipCode ZipCode (Japanese)
     * @returns any Success
     * @throws ApiError
     */
    public static autoCompleteAddressByZipCode(
        zipCode: string,
    ): CancelablePromise<{
        prefecture?: string;
        city?: string;
        townCandidates?: Array<string>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/address/zipcode/{zipCode}',
            path: {
                'zipCode': zipCode,
            },
            errors: {
                400: `Bad Request (zipCode 0000000)`,
                500: `Interval Server`,
            },
        });
    }

}
